export const transformTaskCompletionToString = (original?: number) => {
  if (original === undefined || original < 0) {
    return { percent: '--', progress: 0 };
  }

  return {
    percent: Math.round(original),
    progress: original,
  };
};
